import { I18n } from "react-redux-i18n";
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';;

import { getTestAttributes } from "@common/utils/tests";
import { Button } from "@common/components/Button";
import { MODULE_NAME } from "@modules/individuals";
import { Flex } from "@common/components/Flex";
import { Loading } from "@common/components/loading";
import { Questionnaires } from "../../../questionnaires";
import { getQuestionnaires } from "../../../../actions/questionnaires";
import { getFamilyIdMembersCount, getIndividualFamilyData } from "../../../../actions/individuals";
import { launchNewIndividualQuestionnaire } from "../../../../actions/questionnaires";

import "./new-questionnaire.styles.scss";

export const NewQuestionnaire = (props) => {
  const localModuleName = `${MODULE_NAME}-new-questionnaire`;
  const { onClose, onSubmit, individualName, showErrorMessage, individualId } = props;
  const [submitting, setSubmitting] = React.useState(false);
  const [selectedQuestionnaire, setSelectedQuestionnaire] = React.useState();
  const [individualFamilyMembersCount, setIndividualFamilyMembersCount] = React.useState(0);
  const [initializingComponent, setInitializingComponentState] = React.useState(true);

  React.useEffect(() => {
    getIndividualFamilyData(individualId)
      .then((data) => {
        getFamilyIdMembersCount(data.familyId)
          .then((count) => {
            setIndividualFamilyMembersCount(count);
            setInitializingComponentState(false);
          })
          .catch((err) => {
            showErrorMessage(err?.entity || I18n.t("Failed to get family members data"));
            console.error(err);
          });;
      })
      .catch((err) => {
        showErrorMessage(err?.entity || I18n.t("Failed to get family data"));
        console.error(err);
      });
  }, []);

  const handleSubmit = React.useCallback(async () => {
    setSubmitting(true);

    try {
      const redirectUrl = await launchNewIndividualQuestionnaire(individualId, selectedQuestionnaire.questionnaireId, selectedQuestionnaire.fhq4);
      onSubmit(redirectUrl);
    } catch (err) {
      setSubmitting(false);
      showErrorMessage(err?.entity || I18n.t("Operation failed"));
      console.error(err);
    }
  }, [onSubmit, showErrorMessage, individualId, selectedQuestionnaire]);

  return (
    <Modal
      show
      animation={false}
      bsSize="medium"
      backdrop="static"
      bsClass="bootstrap modal"
      className="IndividualsNewQuestionnaire"
      onEscapeKeyDown={onClose}
      onHide={onClose}
    >
      <ModalHeader closeButton onHide={onClose}>
        <ModalTitle
          {...getTestAttributes(localModuleName, "header", "title")}
        >
          {I18n.t("New Questionnaire for")} {individualName}
        </ModalTitle>
      </ModalHeader>

      <ModalBody>
        {initializingComponent 
          ? <Flex className="IndividualsNewQuestionnaire__loading" justify="center" alignItems="center"><Loading size={30} /></Flex>
          : (
            <Questionnaires 
              getData={() => getQuestionnaires({
                includeFamilyQuestionnaires: individualFamilyMembersCount > 1 ? false : true,
                includeFhq4Questionnaires: true,
              })} 
              title={I18n.t("Select a Questionnaire")}
              selectedQuestionnaire={selectedQuestionnaire} 
              onSelectedQuestionnaireChange={setSelectedQuestionnaire}
            />
          )
        }
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={submitting}
          {...getTestAttributes(MODULE_NAME, "cancel", "button")}
          onClick={onClose}
        >
          {I18n.t("Cancel")}
        </Button>
        <Button
          disabled={submitting || selectedQuestionnaire === undefined}
          bsStyle="primary"
          {...getTestAttributes(localModuleName, "submit", "button")}
          onClick={handleSubmit}
        >
          {submitting ? I18n.t("Loading") : I18n.t('Launch Questionnaire')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
